// extracted by mini-css-extract-plugin
export default {"main":"with_main__pYfcT","form":"with_form__4JZJK","button":"with_button__6mgEn"};